module.exports = __webpack_public_path__ + "img/timer-red.6c062c73.svg";